import axios from '../axios/axios-auth'

export default class BeaconsService {


    getAllBeaconsByOrgId(orgId) {
        return axios.get(`api/v3/organizations/${orgId}/beacons`).then(response => response.data)
    }

    getBeaconsLinksByOrgId(orgId) {
        return axios.get(`api/v3/organizations/${orgId}/beaconLinks`).then(response => response.data)
    }

    createBeaconLink(data) {
        return axios.post(`api/v3/beaconLinks`, data).then(response => response.data)
    }

    deleteBeaconLink(beaconLinkId) {
        return axios.delete(`api/v3/beaconLinks/${beaconLinkId}`).then(response => response.data)
    }

    createImplementBeaconLink(data) {
        return axios.post(`api/v3/implementBeaconLinks`, data).then(response => response.data)
    }

    deleteImplementBeaconLink(beaconLinkId) {
        return axios.delete(`api/v3/implementBeaconLinks/${beaconLinkId}`).then(response => response.data)
    }

}
